import * as ActionTypes from '../constants/ActionTypes';

const initialState = {
	summary: null,
	overtime: null,
	byChannel: null,
	byCategory: null,
	byPaymentMethod: null,
	loadingSummary: false,
	loadingOvertime: false,
	loadingByChannel: false,
	loadingByCategory: false,
	loadingByPaymentMethod: false
};

export default function dashboardPageReducer(state = initialState, action) {
	switch (action.type) {
		case ActionTypes.GET_DASHBOARD_SUMMARY_REQUEST:
		case ActionTypes.GET_DASHBOARD_SUMMARY_ERROR:
		case ActionTypes.GET_DASHBOARD_SUMMARY_SUCCESS:
		case ActionTypes.GET_DASHBOARD_OVERTIME_REQUEST:
		case ActionTypes.GET_DASHBOARD_OVERTIME_ERROR:
		case ActionTypes.GET_DASHBOARD_OVERTIME_SUCCESS:
		case ActionTypes.GET_DASHBOARD_BY_CHANNEL_REQUEST:
		case ActionTypes.GET_DASHBOARD_BY_CHANNEL_ERROR:
		case ActionTypes.GET_DASHBOARD_BY_CHANNEL_SUCCESS:
		case ActionTypes.GET_DASHBOARD_BY_CATEGORY_REQUEST:
		case ActionTypes.GET_DASHBOARD_BY_CATEGORY_ERROR:
		case ActionTypes.GET_DASHBOARD_BY_CATEGORY_SUCCESS:
		case ActionTypes.GET_DASHBOARD_BY_PAYMENT_METHOD_REQUEST:
		case ActionTypes.GET_DASHBOARD_BY_PAYMENT_METHOD_ERROR:
		case ActionTypes.GET_DASHBOARD_BY_PAYMENT_METHOD_SUCCESS:
			return {
				...state,
				...action.payload
			};
		case ActionTypes.RESET_DASHBOARD_META:
			return {
				...state,
				meta: null
			};
		case ActionTypes.RESET_DASHBOARD_PAGE:
			return {
				...initialState
			};
		default:
			return state;
	}
}
